import { docsUrl } from './config';

export const FETCH_INTERVAL = 10000;
export const FOCUS_CHANGE_DEBOUNCE = 100;
export const MESSAGE_MAX_LENGTH = 280;
export const SIDEBAR_WIDTH = 400;

export const docsLinks = {
  webhooks: `${docsUrl}/guides/extensions/#webhook-extension`,
  inbox: `${docsUrl}/api/inbox/`,
  export: `${docsUrl}/guides/import-and-export/#export`,
  schema: `${docsUrl}/guides/queue-schema/#identifiers`,
  validatingPayloads: `${docsUrl}/guides/extensions/#validating-payloads-from-rossum`,
  webhookEvents: `${docsUrl}/guides/extensions/#webhook-events`,
  codeEditorApiDocs: `${docsUrl}/guides/extensions/#serverless-function-extension`,
  sso: `${docsUrl}/guides/overview/#single-sign-on-sso`,
  webhookVsConnector: `${docsUrl}/guides/extensions/#webhook-vs-connector`,
  hookConfiguration: `${docsUrl}/api/hook/`,
  hookSecrets: `${docsUrl}/api/hook/`,
  tokenOwner: `${docsUrl}/guides/extensions/#limitations`,
  userRole: `${docsUrl}/api/user-role/`,
  runtimeDeprecations: `${docsUrl}/guides/extensions/#runtime-deprecations`,
  rirFieldName: `${docsUrl}/guides/queue-schema/#identifiers`,
  txscript: `${docsUrl}/guides/rossum-transaction-scripts/`,
};

const coupaDoc = (resourceId: string) =>
  `https://docs.coupa.com/en/?resourceId=${resourceId}`;
export const DEVELOPER_HUB_LINK = coupaDoc('rossum-api-documentation-5895');
export const HELP_CENTER_LINK = coupaDoc('welcome-to-rossum-9802');
export const CONTACT_FORM_LINK = 'https://rossum.ai/contact';
export const DOC_SPLIT_LINK = coupaDoc('splitting-documents-in-rossum-7052');
export const AUTOMATION_DATA_CAPTURE_LINK = coupaDoc(
  'guide-to-automation-process-in-rossum-3990'
);
export const CONFIRMED_STATE_LINK = coupaDoc('exporting-captured-data-9044');
export const ENUM_EDITOR_LINK = coupaDoc(
  'fill-in-a-dropdown-field-from-a-spreadsheet-4420'
);
export const WEBHOOKS_LINK = coupaDoc('rossum-webhook-6366');
export const FUNCTIONS_LINK = coupaDoc(
  'customize-rossum-logic-with-a-serverless-function-2352'
);
export const KEYBOARD_SHORTCUTS_LINK = coupaDoc('keyboard-shortcuts-1722');
export const CONFIDENCE_THRESHOLDS_LINK = coupaDoc(
  'using-ai-confidence-thresholds-for-automation-in-rossum-7263'
);
export const HOWTO_CREATE_CUSTOM_FIELD_LINK = coupaDoc(
  'how-to-add-a-field-in-json-code-editor-4950'
);
export const HOWTO_CREATE_CUSTOMIZE_TABLE_LINK = coupaDoc(
  'capturing-custom-table-data-in-rossum-9393'
);
export const DEVELOPER_ARTICLE_LINK = coupaDoc(
  'how-to-use-serverless-functions-1305'
);
export const HOWTO_ACCESS_PUBLIC_API_FROM_FUNCTION = coupaDoc(
  'how-to-access-public-api-on-internet-with-rossum-function-8537'
);
export const HOWTO_TEST_FUNCTION = coupaDoc(
  'how-to-test-serverless-functions-9982'
);
export const AUTOMATION_PROCESS = coupaDoc(
  'guide-to-automation-process-in-rossum-3990'
);
export const FIELDS_VALUE_NOT_FOUND = coupaDoc(
  'automation-rules-overview-1159'
);
export const EMAIL_HELP_LINK = coupaDoc('email-forwarding-to-rossum-5393');
export const FIRST_EXTENSION_LINK = coupaDoc(
  'customizing-rossum-functionality-using-extensions-9109'
);
export const AUTOMATION_BUILT_IN_CHECKS = coupaDoc(
  'built-in-checks-overview-5210'
);
export const EXTRACTED_FIELD_TYPES_LINK = `${docsUrl}/api/engine-field/#generic_ap-default`;
export const QUICK_START_GUIDE = coupaDoc('getting-started-with-rossum-7316');
export const ROSSUM_EMAIL_INBOX = coupaDoc('email-inbox-in-rossum-6406');
export const ROSSUM_VIDEOS_LINK = 'https://rossum.ai/resources/demo-hub';
export const CLI_HELP_LINK = coupaDoc('aurora-for-complex-tables-6650');
export const RULES_HOW_TO_LINK = coupaDoc('rules-in-rossum-3808');
export const DATA_CAPTURE_AUTOMATION_LINK = coupaDoc(
  'data-capture-automation-with-rossum-6671'
);

export const BUILTIN_CHECKS_LINK = coupaDoc('built-in-checks-overview-5210');
export const HISTORY_CHECKS_LINK = coupaDoc('history-based-data-checks-1398');
export const CUSTOM_CHECKS_LINK = coupaDoc(
  'implementing-custom-rules-for-automation-in-rossum-8826'
);

export const GITHUB_REGEX2_DOCS =
  'https://github.com/google/re2/wiki/Syntax/c6f0696bfef6b98252894469d6ef8eb70a9c9590';
export const WIKIPEDIA_MIME_TYPE_DOCS =
  'https://en.wikipedia.org/wiki/Media_type';
export const EXTERNAL_CRONTAB_VALIDATOR = 'https://crontab.guru/';

export const DEFAULT_ROW_TYPE = 'data';
export const pageSizeOptions = [10, 15, 20, 25, 50, 100] as const;

export const defaultTheme = 'dark';
export const themeTypes = [defaultTheme, 'white', 'coupa'] as const;
export type ThemeType = (typeof themeTypes)[number];

export const statusPageURL = 'https://status.rossum.ai';
export const contactSupportLink = 'mailto:support@rossum.ai';
export const termsAndConditionsURL = 'https://rossum.ai/terms';

export const UPLOAD_HASH = '#upload';

export const defaultWorkspaceSorting = 'alphabeticalAsc';
